import React from 'react'
import { SpeedDialInterface } from 'interfaces'
import { useHistory } from 'react-router'
import styled from 'styled-components'
import Ribbon from 'components/public/widget/Ribbon'

interface Props {
  data: SpeedDialInterface
  onClick?: (e: any) => void
  className?: string
  iconClassName?: string
  titleClassName?: string
  isSoon?: boolean,
  commingSoonMain?: string,
  isBadges?: boolean,
}

const MenuButton: React.FC<Props> = (props) => {
  const {
    data,
    onClick,
    className,
    iconClassName,
    titleClassName,
    isSoon,
    isBadges,
    commingSoonMain,
  } = props
  const history = useHistory()

  const clickHandler = (e: any): void => {
    e.preventDefault()
    if (data.link) history.push(data.link)
    if (onClick) onClick(e)
  }

  return (
    <div className={`speed-dial ${className ?? ''}`} onClick={clickHandler}>
      {isSoon && (
        <Ribbon isBadges={false} text="به زودی"/>
      )}
      {isBadges && (
        <Ribbon isBadges={false} text="به زودی" />
      )}
      <span className={iconClassName}>{data.icon} </span>
      <br />
      <span className={titleClassName}>
        {data.title}
      </span>
    </div>
  )
}

export default MenuButton
